<template>
  <v-container>
    <v-list three-line>
      <template>
        <v-subheader
          style="height:20px;"
        >お知らせ</v-subheader>
        <div style="overflow: scroll; height: 275px;">
          <NotificationListItem
            :noticeList="noticeList" :closeModal="closeModal"
            :parentComponent="componentName" :setUnReadNotice="setUnReadNotice"
            />
        </div>
        <v-divider></v-divider>
        <div style="display:flex;justify-content: center;align-items: center;">
          <v-btn @click="moveNotificationIndex" style="height: 20px;">お知らせ一覧ページへ</v-btn>
        </div>
      </template>
    </v-list>
  </v-container>
</template>
<script>
import NotificationListItem from '../molecules/NotificationListItem.vue';
export default {
  data() {
    return {
      isLoading: false,
      isMoreData: true,
    };
  },
  name: 'NoticeList',
  components: {
    NotificationListItem
  },
  props: ['closeModal', 'noticeList', 'setUnReadNotice'],
  methods: {
    moveNotificationIndex() {
      this.closeModal();
      this.$router.push('/notification');
    },
  },
  computed: {
    componentName() {
      return this.$options.name;
    }
  },
}
</script>
<style scoped>
</style>